import type { Option } from "./types";

const commonOptions: Option[] = [
  {
    label: { season: "", year: "2023" },
    value: "whole_2023",
  },
  {
    label: { season: "", year: "2022" },
    value: "whole_2022",
  },
  {
    label: { season: "", year: "2019" },
    value: "whole_2019",
  },
  {
    label: { season: "winter", year: "2017/2018" },
    value: "winter_17",
  },
  {
    label: { season: "winter", year: "2016/2017" },
    value: "winter_16",
  },
];

const options: Record<"airlines" | "airports", Option[]> = {
  airlines: [
    ...commonOptions,
    {
      label: { season: "autumn", year: "2016" },
      value: "autumn_16",
    },
    {
      label: { season: "summer", year: "2016" },
      value: "summer_16",
    },
    {
      label: { season: "spring", year: "2016" },
      value: "spring_16",
    },
    {
      label: { season: "winter", year: "2015/2016" },
      value: "winter_15",
    },
    {
      label: { season: "autumn", year: "2015" },
      value: "autumn_15",
    },
  ],
  airports: [...commonOptions],
};

export default options;
